import { Box, Container } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';

import { Routes } from 'constants/routes.constants';

import { BackButton } from 'components/@common';

import StepIndicator from '../StepIndicator';

const steps = [
  { name: 'language', route: Routes.Root },
  { name: 'package', route: Routes.Language },
  { name: 'student', route: Routes.Student },
  { name: 'overview', route: Routes.Checkout },
  { name: 'billing', route: Routes.Checkout },
];

interface Props {
  activeStep: number;
  onBack?(): void;
}

const StepContainer: React.FC<Props> = ({ activeStep, onBack, children }) => {
  const intl = useIntl();

  const handleBack = () => {
    if (onBack) onBack();
  };

  return (
    <Container>
      <Box
        display={{ xs: 'flex', md: 'block' }}
        justifyContent={{ xs: !!activeStep ? 'space-between' : 'flex-end' }}
        alignItems={{ xs: 'center' }}
        mb={{ xs: 4, md: 10 }}
      >
        {!!activeStep && (
          <Box mb={{ md: 4 }}>
            <BackButton onClick={handleBack} text="label.previous" />
          </Box>
        )}
        <Box mt={{ md: !!activeStep ? 0 : 12 }}>
          <StepIndicator
            steps={steps.map(({ name }) =>
              intl.formatMessage({ id: `order_flow.step.${name}.label` }),
            )}
            activeStep={activeStep}
          />
        </Box>
      </Box>
      {children}
    </Container>
  );
};

export default StepContainer;
